import { SavedPrinter, UsbDevice } from "../models/printer";

const DB_NAME = "printers";
const STORE_NAME = "connected_printers";

function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onerror = () => reject("Error opening DB");
    request.onsuccess = () => resolve(request.result);
    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      db.createObjectStore(STORE_NAME, { keyPath: "id" });
    };
  });
}

export async function addPrinter(printer: SavedPrinter): Promise<void> {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], "readwrite");
    const store = transaction.objectStore(STORE_NAME);
    const request = store.add(printer);
    request.onsuccess = () => resolve();
    request.onerror = () => reject("Error adding printer");
  });
}

export async function deletePrinter(serial: string): Promise<void> {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], "readwrite");
    const store = transaction.objectStore(STORE_NAME);
    const request = store.delete(serial);
    request.onsuccess = () => resolve();
    request.onerror = () => reject("Error deleting printer");
  });
}

export async function getSavedPrinters(): Promise<SavedPrinter[]> {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], "readonly");
    const store = transaction.objectStore(STORE_NAME);
    const request = store.getAll();
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject("Error getting printers");
  });
}
